<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { Data } from '~~/server/api/insurance/assistance-services/[slug]'

export interface WidgetAssistanceServicesProps {
    data: Data;
}

const { $t } = useNuxtApp()

const props = defineProps<WidgetAssistanceServicesProps>()
const filterTitle = $t('Zobraziť služby dostupné v poistení:')
const productsTitle = $t('Službu môžete mať v poistení')
</script>
<template>
  <article class="row">
    <div class="col-lg-10 mx-auto">
      <p class="mb-4 fs-bigger beta">
        {{ filterTitle }}
      </p>
      
      <Tracker :data="{ position: filterTitle }">
        <WidgetAssistanceServicesFilter
          :filter-data="props.data.filter_products"
        />
      </Tracker>

      <Card
        v-for="(service, index) in props.data.services"
        :key="`asiss-serv-${index}`"
        class="mb-4 p-4 p-md-8 mb-md-12"
      >
        <Tracker :data="{ position: service.title }">
          <div class="row">
            <div class="col-12 col-md-7">
              <section
                class="left-content mb-4 mb-md-0 pb-4 pb-md-0 pe-md-6"
              >
                <p class="fw-bold text-secondary mb-2">
                  {{ $t("Asistenčná služba") }}
                </p>

                <h3 class="fw-bold mb-4 fs-bigger">
                  {{ service.title }}
                </h3>

                <Typo class="mb-8">
                  <div v-html="service.description_2nd" />
                </Typo>

                <VButton
                  v-if="service.cta_product"
                  :to="service.cta_product.link"
                  :target="
                    service.cta_product.isExternal
                      ? '_blank'
                      : '_self'
                  "
                  :label="service.cta_product.text"
                >
                  {{ service.cta_product.text }}
                </VButton>
              </section>
            </div>

            <section class="col-12 col-md-5">
              <Tracker :data="{ title: productsTitle }">
                <h4 class="mb-2 fs-small">
                  {{ productsTitle }}:
                </h4>
                <ul class="d-flex flex-column gap-2">
                  <li
                    v-for="(
                      product, index2
                    ) in service.products"
                    :key="`assist-servi-prod-${index2}`"
                    class="d-flex"
                  >
                    <Label
                      :label="product.title"
                      :to="
                        useNamedRoutes({
                          name: 'insurance-detail',
                          params: {
                            category:
                              product.category
                                .slug,
                            id: product.slug,
                          },
                        })
                      "
                      background-color="var(--global-color-secondary)"
                      text-color="var(--global-color-white)"
                      size="big"
                    />
                  </li>
                </ul>
              </Tracker>
            </section>
          </div>
        </Tracker>
      </Card>

      <Typo v-if="props.data.note">
        <div v-html="props.data.note" />
      </Typo>
    </div>
  </article>
</template>

<style lang="scss" scoped>
@import "./WidgetAssistanceServices.scss";
</style>
